import { JsonInput } from 'components/UI/JsonForm/JsonInputRenderer/types';
import { IApplicationFormStep } from 'features/ApplicationForm/types';
import { States } from '../../../../constants';
import FBDICourse from './FBDI Course';

const howInformation: JsonInput[] = [
  {
    type: 'input',
    props: {
      name: 'howInfo.name',
      label: 'House of Worship Name',
    },
  },
  {
    type: 'input',
    props: {
      name: 'howInfo.website',
      label: 'Website (If Applicable)',
    },
  },
  {
    type: 'input',
    props: {
      name: 'howInfo.address',
      label: 'House of Worship Address',
    },
  },
  {
    type: 'input',
    props: {
      name: 'howInfo.city',
      label: 'City',
    },
  },
  {
    type: 'select',
    gridColSpan: 'col-span-4',
    props: {
      name: 'howInfo.state',
      label: 'State',
      options: States.map((state) => ({
        label: state.name,
        value: state.abbreviation,
      })),
    },
  },
  {
    type: 'masked',
    gridColSpan: 'col-span-4',
    props: {
      name: 'howInfo.zipCode',
      label: 'Zip / Postal Code',
      maskedComponent: 'zipCode',
    },
  },
  {
    type: 'input',
    props: {
      name: 'howInfo.clergyLeader',
      label: 'Clergy Leader',
    },
  },
  {
    type: 'masked',
    props: {
      name: 'howInfo.phone',
      label: 'Phone',
      maskedComponent: 'phone',
    },
  },
  {
    type: 'input',
    props: {
      name: 'howInfo.email',
      label: 'Email',
    },
  },
];

const howStructure: JsonInput[] = [
  {
    type: 'radio-group',
    gridColSpan: 'col-span-12',
    props: {
      name: 'howStructure.q1',
      label: 'Is there a committee/team responsible for a development project?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'input',
    isDependent: true,
    dependentInputName: 'howStructure.q1',
    dependentInputValue: 'yes',
    props: {
      name: 'howStructure.q1-boardChair',
      label: 'Committee/Team Leader',
    },
  },
  {
    type: 'masked',
    isDependent: true,
    dependentInputName: 'howStructure.q1',
    dependentInputValue: 'yes',
    props: {
      name: 'howStructure.q1-phone',
      label: 'Phone',
      maskedComponent: 'phone',
    },
  },
  {
    type: 'input',
    isDependent: true,
    dependentInputName: 'howStructure.q1',
    dependentInputValue: 'yes',
    props: {
      name: 'howStructure.q1-email',
      label: 'Email',
    },
  },
  {
    type: 'radio-group',
    gridColSpan: 'col-span-12',
    props: {
      name: 'howStructure.q2',
      label:
        'Is there a non-profit organization affiliated with the house of worship?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'radio-group',
    gridColSpan: 'col-span-12',
    isDependent: true,
    dependentInputName: 'howStructure.q2',
    dependentInputValue: 'yes',
    props: {
      name: 'howStructure.q3',
      label:
        'Does organization possess 501(c)3 tax exempt status or is in the process of securing it?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'input',
    isDependent: true,
    dependentInputName: 'howStructure.q3',
    dependentInputValue: 'yes',
    props: {
      name: 'howStructure.q3-nonProfitName',
      label: 'Name of Non-Profit',
    },
  },
  {
    type: 'input',
    isDependent: true,
    dependentInputName: 'howStructure.q3',
    dependentInputValue: 'yes',
    gridColSpan: 'col-span-8',
    props: {
      name: 'howStructure.q3-nonProfitAddress',
      label: 'Address of Non-Profit',
    },
  },
  {
    type: 'input',
    isDependent: true,
    dependentInputName: 'howStructure.q3',
    dependentInputValue: 'yes',
    props: {
      name: 'howInfo.q3-website',
      label: 'Website (If Applicable)',
    },
  },
  {
    type: 'input',
    isDependent: true,
    dependentInputName: 'howStructure.q3',
    dependentInputValue: 'yes',
    props: {
      name: 'howStructure.q3-executiveDirector',
      label: 'Organizational Leader',
    },
  },
  {
    type: 'masked',
    isDependent: true,
    dependentInputName: 'howStructure.q3',
    dependentInputValue: 'yes',
    props: {
      name: 'howStructure.q3-phone',
      label: 'Phone',
      maskedComponent: 'phone',
    },
  },
  {
    type: 'input',
    isDependent: true,
    dependentInputName: 'howStructure.q3',
    dependentInputValue: 'yes',
    props: {
      name: 'howStructure.q3-email',
      label: 'Email',
    },
  },
  {
    type: 'masked',
    isDependent: true,
    dependentInputName: 'howStructure.q3',
    dependentInputValue: 'yes',
    props: {
      name: 'howStructure.q3-fteCount',
      label: 'No. of Full-Time Staff',
      maskedComponent: 'numeric',
    },
  },
  {
    type: 'masked',
    isDependent: true,
    dependentInputName: 'howStructure.q3',
    dependentInputValue: 'yes',
    props: {
      name: 'howStructure.q3-pteCount',
      label: 'No. of Part-Time Staff (Optional)',
      maskedComponent: 'numeric',
    },
  },
  {
    type: 'masked',
    isDependent: true,
    dependentInputName: 'howStructure.q3',
    dependentInputValue: 'yes',
    props: {
      name: 'howStructure.q3-operatingBudget',
      label: 'Total Operating Budget (Optional)',
      maskedComponent: 'currency',
    },
  },
  {
    type: 'masked',
    isDependent: true,
    dependentInputName: 'howStructure.q3',
    dependentInputValue: 'yes',
    props: {
      name: 'howStructure.q3-yearsService',
      label: 'Years Providing Service',
      maskedComponent: 'numeric',
    },
  },
  {
    type: 'date',
    isDependent: true,
    dependentInputName: 'howStructure.q3',
    dependentInputValue: 'yes',
    props: {
      name: 'howStructure.q3-meetingDate',
      label: 'Date of Last Board Meeting (Optional)',
    },
  },
];

const projectInfo: JsonInput[] = [
  {
    type: 'radio-group',
    gridColSpan: 'col-span-12',
    props: {
      name: 'projectInfo.q1',
      label:
        'Do you want to complete an affordable housing and/or community facility development project ?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'textarea',
    isDependent: true,
    dependentInputName: 'projectInfo.q1',
    dependentInputValue: 'no',
    props: {
      name: 'projectInfo.q1-nf1',
      label:
        'Please explain your interest in the faith-based development guide.',
    },
  },
  {
    type: 'input',
    isDependent: true,
    dependentInputName: 'projectInfo.q1',
    dependentInputValue: 'yes',
    props: {
      name: 'projectInfo.q1-propertyAddress',
      label: 'Project Address',
    },
  },
  {
    type: 'input',
    isDependent: true,
    dependentInputName: 'projectInfo.q1',
    dependentInputValue: 'yes',
    props: {
      name: 'projectInfo.q1-propertyOwner',
      label: 'Legal Property Owner',
    },
  },
  {
    type: 'select',
    isDependent: true,
    dependentInputName: 'projectInfo.q1',
    dependentInputValue: 'yes',
    props: {
      name: 'projectInfo.q1-f3',
      label: 'Status of Site Control',
      options: [
        { label: 'Own the land - no debt', value: 'Own the land - no debt' },
        {
          label: 'Own the land - with debt',
          value: 'Own the land - with debt',
        },
        { label: 'Do not own the land', value: 'Do not own the land' },
      ],
    },
  },
  {
    type: 'radio-group',
    isDependent: true,
    dependentInputName: 'projectInfo.q1',
    dependentInputValue: 'yes',
    gridColSpan: 'col-span-12',
    props: {
      name: 'projectInfo.q1-propertyCurrentlyVacant',
      label: 'Is there a building on the property ?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'radio-group',
    isDependent: true,
    dependentInputName: 'projectInfo.q1-propertyCurrentlyVacant',
    dependentInputValue: 'yes',
    gridColSpan: 'col-span-12',
    props: {
      name: 'projectInfo.q1-demolished',
      label: 'Will the building need to be demolished ?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'radio-group',
    isDependent: true,
    dependentInputName: 'projectInfo.q1',
    dependentInputValue: 'yes',
    gridColSpan: 'col-span-12',
    props: {
      name: 'projectInfo.q1-haveLegalCounsel',
      label: 'Do you have legal counsel for this project ?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'radio-group',
    isDependent: true,
    dependentInputName: 'projectInfo.q1',
    dependentInputValue: 'yes',
    gridColSpan: 'col-span-12',
    props: {
      name: 'projectInfo.q1-haveConsultantPartner',
      label: 'Do you have a development consultant?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'radio-group',
    isDependent: true,
    dependentInputName: 'projectInfo.q1',
    dependentInputValue: 'yes',
    gridColSpan: 'col-span-12',
    props: {
      name: 'projectInfo.q1-haveDevelopmentPartner',
      label: 'Do you have a development partner ?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'radio-group',
    isDependent: true,
    dependentInputName: 'projectInfo.q1',
    dependentInputValue: 'yes',
    gridColSpan: 'col-span-12',
    props: {
      name: 'projectInfo.q1-haveMarketAnalysis',
      label: 'Do you have a market study ?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'radio-group',
    isDependent: true,
    dependentInputName: 'projectInfo.q1',
    dependentInputValue: 'yes',
    gridColSpan: 'col-span-12',
    props: {
      name: 'projectInfo.q1-haveDevelopmentBudgetProforma',
      label: 'Do you have a development budget and pro-forma for project ?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'radio-group',
    isDependent: true,
    dependentInputName: 'projectInfo.q1',
    dependentInputValue: 'yes',
    gridColSpan: 'col-span-12',
    props: {
      name: 'projectInfo.q1-haveFeasibilityAnalysis',
      label: 'Do you have a feasibility analysis ?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
  {
    type: 'radio-group',
    isDependent: true,
    dependentInputName: 'projectInfo.q1',
    dependentInputValue: 'yes',
    gridColSpan: 'col-span-12',
    props: {
      name: 'projectInfo.q1-hadArchitecturalDrawings',
      label: 'Have you had architectural drawings done ?',
      options: [
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' },
      ],
    },
  },
];

const developmentAndCommunityGoals: JsonInput[] = [
  {
    type: 'checkbox-group',
    props: {
      name: 'developmentAndCommunityGoals.goals',
      label: 'Please select all that represent your development goals.',
      orientation: 'vertical',
      options: [
        {
          label: 'Develop affordable for-sale housing',
          value: 'Develop affordable for-sale housing',
        },
        {
          label: 'Develop affordable rental senior housing',
          value: 'Develop affordable rental senior housing',
        },
        {
          label: 'Develop affordable rental family housing',
          value: 'Develop affordable rental family housing',
        },
        {
          label: 'Develop permanently supportive rental housing',
          value: 'Develop permanently supportive rental housing',
        },
        {
          label: 'Develop mixed-income rental housing',
          value: 'Develop mixed-income rental housing',
        },
        {
          label: 'Adaptive reuse of an existing building',
          value: 'Adaptive reuse of an existing building',
        },
        {
          label: 'Develop neighborhood serving retail',
          value: 'Develop neighborhood serving retail',
        },
        {
          label: 'Develop community serving office/commercial space',
          value: 'Develop community serving office/commercial space',
        },
        {
          label: 'Develop childcare center',
          value: 'Develop childcare center',
        },
        {
          label: 'Develop health clinic',
          value: 'Develop health clinic',
        },
        {
          label: 'Develop market/grocery',
          value: 'Develop market/grocery',
        },
      ],
    },
  },
  {
    type: 'textarea',
    gridColSpan: 'col-span-9',
    props: {
      name: 'developmentAndCommunityGoals.other',
      label:
        'Please  provide more details as appropriate and/or other goals you may have',
    },
  },
];

const fbdiGoals: JsonInput[] = [
  {
    type: 'checkbox-group',
    gridColSpan: 'col-span-12',
    props: {
      name: 'fbdiGoals.goals',
      label: 'Please select all that represent your FBDI goals.',
      orientation: 'vertical',
      options: [
        {
          label:
            'Gain an initial understanding of the development process (currently have little to no previous experience)',
          value:
            'Gain an initial understanding of the development process (currently have little to no previous experience)',
        },
        {
          label:
            'Gain a deeper understanding of the development process (currently have a moderate level of knowledge or experience)',
          value:
            'Gain a deeper understanding of the development process (currently have a moderate level of knowledge or experience)',
        },
        {
          label:
            'We have a high level of understanding but would like to know more about a specific aspect of the development process.',
          value:
            'We have a high level of understanding but would like to know more about a specific aspect of the development process.',
        },
        {
          label:
            'Understand options for development relationships and partnerships',
          value:
            'Understand options for development relationships and partnerships',
        },
        {
          label: 'Understand options for development financing',
          value: 'Understand options for development financing',
        },
        {
          label:
            'Understand options for financial relationships between houses of worship and development partners',
          value:
            'Understand options for financial relationships between houses of worship and development partners',
        },
        {
          label:
            'Understand how to identify and pay for professionals on your project team',
          value:
            'Understand how to identify and pay for professionals on your project team',
        },
        {
          label: 'Access resources to support execution of development',
          value: 'Access resources to support execution of development',
        },
      ],
    },
  },
  {
    type: 'textarea',
    gridColSpan: 'col-span-8',
    props: {
      name: 'fbdiGoals.other',
      label: 'Other Goals',
    },
  },
];

export const FBDISteps: IApplicationFormStep[] = [
  {
    title: 'H.O.W Info',
    sections: [
      {
        id: 'howInfo',
        title: 'House of Worship Information',
        subTitle: 'Please provide information about your House of Worship',
        inputs: howInformation,
      },
    ],
  },
  {
    title: 'H.O.W Structure',
    sections: [
      {
        id: 'howStructure',
        title: 'House of Worship Structure',
        subTitle:
          'Please provide information about the structure of your house of worship',
        inputs: howStructure,
      },
    ],
  },
  {
    title: 'Project Info',
    sections: [
      {
        id: 'projectInfo',
        title: 'Project Information',
        subTitle: 'Please provide information about your project',
        inputs: projectInfo,
      },
    ],
  },
  {
    title: 'Development & Community Goals',
    sections: [
      {
        id: 'developmentAndCommunityGoals',
        title: 'Development And Community Goals',
        subTitle:
          'Please provide information about the development and community goals',
        inputs: developmentAndCommunityGoals,
      },
    ],
  },
  {
    title: 'FBDI Goals',
    sections: [
      {
        id: 'fbdiGoals',
        title: 'FBDI Goals',
        subTitle: 'Please provide information about your FBDI goals',
        inputs: fbdiGoals,
      },
    ],
  },
  {
    title: 'FBDI Course',
    sections: [],
    component: FBDICourse,
  },
];
